<template>
  <svg onclick="window.open('https://www.linkedin.com/company/104908345/')" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
    <path
      class="normal"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM15.1633 40.25H21.0505V22.5384H15.1633V40.25ZM18.0687 20.1199H18.1071C20.1601 20.1199 21.4377 18.76 21.4377 17.0603C21.3994 15.3223 20.1601 14 18.1462 14C16.1323 14 14.8155 15.3223 14.8155 17.0603C14.8155 18.76 16.0932 20.1199 18.0687 20.1199ZM36.3919 40.25H42.2783V30.0942C42.2783 24.6541 39.374 22.1227 35.5007 22.1227C32.3773 22.1227 30.9776 23.8393 30.1952 25.0462V22.5384H24.3085C24.3856 24.2001 24.3085 40.25 24.3085 40.25H30.1952V30.359C30.1952 29.8297 30.2332 29.3008 30.3889 28.9224C30.8145 27.8649 31.7831 26.7694 33.4094 26.7694C35.5394 26.7694 36.3919 28.3935 36.3919 30.7747V40.25Z"
      fill="currentColor"
    />
    <path
      class="hover"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM15.1633 40.25H21.0505V22.5384H15.1633V40.25ZM18.0687 20.1199H18.1071C20.1601 20.1199 21.4377 18.76 21.4377 17.0603C21.3994 15.3223 20.1601 14 18.1462 14C16.1323 14 14.8155 15.3223 14.8155 17.0603C14.8155 18.76 16.0932 20.1199 18.0687 20.1199ZM36.3919 40.25H42.2783V30.0942C42.2783 24.6541 39.374 22.1227 35.5007 22.1227C32.3773 22.1227 30.9776 23.8393 30.1952 25.0462V22.5384H24.3085C24.3856 24.2001 24.3085 40.25 24.3085 40.25H30.1952V30.359C30.1952 29.8297 30.2332 29.3008 30.3889 28.9224C30.8145 27.8649 31.7831 26.7694 33.4094 26.7694C35.5394 26.7694 36.3919 28.3935 36.3919 30.7747V40.25Z"
      fill="#0077B5"
    />
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  --transition: opacity 0.3s;

  .normal {
    opacity: 1;
    transition: var(--transition);
  }
  .hover {
    opacity: 0;
    transition: var(--transition);
  }

  @media (hover: hover) {
    &:hover {
      .normal {
        opacity: 0;
      }
      .hover {
        opacity: 1;
      }
    }
  }

  @media (hover: none) {
    &:active {
      .normal {
        opacity: 0;
      }
      .hover {
        opacity: 1;
      }
    }
  }
}
</style>
